export interface ISortItem {
	name: string;
	checked: boolean;
	static: boolean;
}

export interface ISortUpdatedEvent {
	data: ISortItem[];
	newIndex: number;
	previousIndex: number;
}

export class SortLocale {
	sortArrowUpLabel: string = 'Move item up';
	sortArrowDownLabel: string = 'Move item down';
}
